import React, { FC, useState } from 'react'
import { createUseStyles } from 'react-jss'
import { useAtom } from 'jotai'
import { Dialog } from '../../ui/Dialog/Dialog'
import { Foa } from '../../../assets/icons'
import { baseButton } from '../../../theme/reuseables'
import { L, L_HTML } from '../../providers/Lokalise'
import { Circle } from '../../ui/Card'
import { CircleIcon } from '../../ui/Circle/Circle'
import { Typography } from '../../ui/Typography/Typography'
import { Button } from '../../ui/Button/Button'
import { colors } from '../../../theme/palette'
import { profileAtom } from '../../../api/profile/profile'
import { ImitatorNoAccessWarning } from '../Imitator/ImitatorNoAccessWarning'

const useStyles = createUseStyles({
    button: {
        ...baseButton,
        ...{
            margin: 0,
            padding: '0.5rem 0rem 0.5rem 2rem',
            cursor: 'pointer',
        },
    },
    linkArea: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '250px',
        width: '100%',
        alignItems: 'center',
        marginTop: '20px',
        '& p': {
            margin: '20px 0',
        },
        '& button': {
            width: '100%',
            flexGrow: 1,
        },
    },
})

const SignupMemberModal: FC = () => {
    const classes = useStyles()
    const [authProfile] = useAtom(profileAtom)
    const [showImitatorModal, setShowImitatorModal] = useState(false)

    return (
        <>
            <Dialog
                trigger={
                    <button type="button" className={classes.button}>
                        <Circle marginRight=".5rem">
                            <CircleIcon
                                backgroundColor={colors.white}
                                borderColor={colors.gray700}
                                borderWidth="1px"
                            >
                                <Foa color={colors.red500} />
                            </CircleIcon>
                        </Circle>
                        <Typography tag="h3" size="M" spacing=".2rem">
                            {L_HTML('BLANKETTER_POPUP_ÅBEN_KNAP')}
                        </Typography>
                    </button>
                }
                icon={<Foa color={colors.red500} width="55px" />}
                iconBGColor={colors.white}
                iconBorder={colors.borderColor}
            >
                <Typography
                    style={{ marginBottom: '30px' }}
                    size="L"
                    align="center"
                >
                    {L_HTML('BLANKETTER_POPUP_OVERSKRIFT')}
                </Typography>
                <Typography size="XS">
                    {L_HTML('BLANKETTER_POPUP_TEXT')}
                </Typography>
                <div className={classes.linkArea}>
                    {/* <Typography size="L">
                        {L_HTML('BLANKETTER_POPUP_INDEMELDELSE_TEXT')}
                    </Typography> */}
                    <Button
                        size="large"
                        onClick={() => {
                            if (authProfile.isImitator) {
                                setShowImitatorModal(true)
                            } else {
                                window.open(
                                    // eslint-disable-next-line max-len
                                    process.env.REACT_APP_LINK_INDEMELDELSE,
                                    '_blank'
                                )
                            }
                        }}
                    >
                        {L_HTML('BLANKETTER_POPUP_INDEMELDELSE_KNAP')}
                    </Button>
                </div>

                <div className={classes.linkArea}>
                    {/* <Typography size="L">
                        {L_HTML('BLANKETTER_POPUP_RINGOP_TEXT')}
                    </Typography> */}
                    <Button
                        size="large"
                        onClick={() => {
                            if (authProfile.isImitator) {
                                setShowImitatorModal(true)
                            } else {
                                window.open(
                                    // eslint-disable-next-line max-len
                                    process.env.REACT_APP_LINK_RING_MIG_OP,
                                    '_blank'
                                )
                            }
                        }}
                    >
                        {L_HTML('BLANKETTER_POPUP_RINGOP_KNAP')}
                    </Button>
                </div>
                <div className={classes.linkArea}>
                    {/* <Typography size="L">
                        {' '}
                        {L_HTML('BLANKETTER_POPUP_KONTIGENT_TEXT')}
                    </Typography> */}
                    <Button
                        size="large"
                        onClick={() => {
                            window.open(
                                // eslint-disable-next-line max-len
                                'https://www.foa.dk/bliv-medlem/kontingenter?utm_source=MineMedlemmer&utm_medium=web&utm_campaign=tillidsvalgt',
                                '_blank'
                            )
                        }}
                    >
                        {L_HTML('BLANKETTER_POPUP_KONTIGENT_KNAP')}
                    </Button>
                </div>
            </Dialog>
            <ImitatorNoAccessWarning
                show={showImitatorModal}
                onClose={() => setShowImitatorModal(false)}
            />
        </>
    )
}

export { SignupMemberModal }
